import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DISTRIBUTION_STATUS } from 'shared/constants/distribution';
import { Tag, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import LicenseTag from 'components/LicenseTag';
import theme from 'shared/constants/theme.json';
import { SURVEY_TYPE_LIMITS } from 'shared/constants/settings';
import { Link } from 'react-router-dom';
import messages from './messages';

const { ACTIVE, INACTIVE, SCHEDULED, MISSING_LICENSE, LICENSE_LIMIT } = DISTRIBUTION_STATUS;

const SurveyLimitLicenseTag = ({ type, showTooltip }) => {
  const limitSetting = SURVEY_TYPE_LIMITS[type];

  return <LicenseTag setting={limitSetting} showTooltip={showTooltip} />;
};

const DistributionStatusTag = ({ status, showTooltip, loading, type, ...rest }) => {
  let color;

  if (!loading) {
    switch (status) {
      case ACTIVE:
        color = theme['success-color'];
        break;
      case SCHEDULED:
        color = theme['warning-color'];
        break;
      case MISSING_LICENSE:
      case LICENSE_LIMIT:
        return <SurveyLimitLicenseTag type={type} showTooltip={showTooltip} />;
      default:
        color = theme['error-color'];
        break;
    }

    if (!status) {
      status = INACTIVE;
    }
  }

  let tag = (
    <Tag color={color} icon={loading ? <LoadingOutlined spin /> : false} {...rest}>
      {!loading && messages[status] && <FormattedMessage {...messages[status]} />}
    </Tag>
  );

  if (showTooltip && messages[`${status}_tooltip`]) {
    tag = <Tooltip title={<FormattedMessage {...messages[`${status}_tooltip`]} values={{ accountPrivacyLink: chunks => <Link to="/account/privacy">{chunks}</Link> }} />}>{tag}</Tooltip>;
  }

  return tag;
};

export default DistributionStatusTag;
